<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-xl">
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-displays">Contratos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="openContractDialog" text color="primary">
              Adicionar
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>

          <v-col cols="12">
            <v-text-field style="padding: 1em" class="px-4" prepend-icon="search" label="Buscar"
                          v-model="searchText" hint="Buscar por nome do Template" persistent-hint />
          </v-col>

          <v-data-table :loading="isLoading" no-data-text="Sem templates para exibir" :headers="headers"
                        :items="searchedContracts">
            <template v-slot:item.actions="{ item }">
              <v-icon small color="primary" class="mr-2" @click="editContract(item)">
                mdi-pencil
              </v-icon>
              <v-icon small color="error" @click="handleClickDeleteContract(item)">
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:item.fileName="{ item }">
              <div style="cursor: pointer; text-decoration: underline; color: dodgerblue; "
                   @click="handleViewFile(item)">
                <v-icon class="mr-2" style="color: dodgerblue;">
                  mdi-eye
                </v-icon>
                <span>{{ item.fileName }}</span>


              </div>
            </template>

            <template v-slot:item.createdAt="{ item }">
              <span>{{ formattedDate(item.createdAt) }}</span>
            </template>

            <template v-slot:item.isActive="{ item }">
              <span>{{ item.isActive ? 'Ativo' : 'Inativo' }}</span>
            </template>

          </v-data-table>
          <v-dialog v-model="showFileDialog" max-width="800px" scrollable>
            <v-card>
              <v-card-title class="headline" style="font-weight: 700; font-size: 1.5em; text-align: center;">
                <span>Visualizar Template de Contrato</span>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mr-3" @click="handleDownload(contract)">Baixar</v-btn>
                <v-btn color="secondary" @click="showFileDialog = false">Fechar</v-btn>
              </v-card-title>

              <v-card-text>
                <div v-html="fileContent" style="max-height: 600px; overflow-y: auto; padding: 20px;"></div>
                <p v-if="!fileContent" style="text-align: center;">Aguardando carregamento...</p>
              </v-card-text>
            </v-card>
          </v-dialog>

        </v-card>
      </v-col>
    </v-row>

    <v-dialog max-width="1400" v-if="contractDialog" v-model="contractDialog" persistent>
      <v-form ref="contractTemplates" v-model="validForm" lazy-validation>
        <v-card>
          <v-toolbar style="position: sticky;
                          top: 0;
                          z-index: 1000;" dark color="primary">
            <v-btn icon dark @click="closeContractDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ defineModalTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="saveContract()" :loading="isLoading">
                Salvar
              </v-btn>
              <v-dialog v-model="processingModal" max-width="400" persistent>
                <v-list class="py-5" color="primary" elevation="12" rounded>
                  <v-list-item class="d-flex justify-space-between">
                    <div>
                      <span style="color: white; font-size: large;">Salvando Template de Contrato</span>
                    </div>
                    <div>
                      <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
                    </div>
                  </v-list-item>
                </v-list>
              </v-dialog>
            </v-toolbar-items>
          </v-toolbar>
          <v-card class="pa-4" outlined color="grey lighten-4" elevation="2">

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="contract.templateName"
                  label="Nome do Template"
                  outlined
                  :rules="ruleRequired"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-switch v-model="contract.isActive" :label="contract.isActive ? 'Ativo' : 'Inativo'"
                          :true-value="true" :false-value="false" style="margin-top: -40px;"
                ></v-switch>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field style="padding: 1em" class="px-4" prepend-icon="search" label="Buscar"
                              v-model="searchTextAnchors" hint="Buscar por nome da âncora" persistent-hint />
              </v-col>
            </v-row>

            <v-row cols="12" class="d-flex flex-column align-start">
            <span class="text-h5 font-weight-bold" style="color: #000; margin-left: 10px;">
              Âncoras Sugeridas
            </span>
              <v-divider style="width: 100%;"></v-divider>
            </v-row>

            <v-row>
              <v-col
                v-for="category in filteredSuggestedAnchors"
                :key="category.name"
                cols="12"
              >
                <h3 style="margin-bottom: 10px;">{{ category.name.toUpperCase() }}</h3>

                <v-chip
                  v-for="anchor in category.anchors"
                  :key="anchor"
                  class="ma-2"
                  outlined
                  color="primary"
                  @click="copyAnchorToClipboard(formatAnchor(anchor))"
                  style="
                    cursor: pointer;
                    user-select: none;">
                  {{ formatAnchor(anchor) }}
                </v-chip>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card class="pa-4 mb-4" outlined color="grey lighten-4" elevation="2">
                <span class="text-h5 font-weight-bold" style="color: #000;">
                  Âncoras Personalizadas
                </span>
                  <v-divider style="width: 100%;"></v-divider>

                  <v-row cols="12" class="mt-3 d-flex align-center">
                    <v-col cols="4" md="6" lg="4">
                      <v-text-field
                        v-model="newCustomAnchor"
                        label="Adicionar Âncora Personalizada"
                        outlined
                        clearable
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4" md="3" lg="2" class="mb-7">
                      <v-btn
                        color="primary"
                        @click="addCustomAnchor"
                        :disabled="!newCustomAnchor.trim() || isLoadingButtonAddCustomAnchor"
                        :loading="isLoadingButtonAddCustomAnchor"
                        style="border-radius: 8px; transition: 0.2s; padding: 20px"
                        :style="{
                          cursor: newCustomAnchor.trim() ? 'pointer' : 'not-allowed',
                          opacity: newCustomAnchor.trim() ? 1 : 0.6,
                        }">
                        Adicionar
                        <v-icon right>mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>


                  <v-chip
                    v-for="anchor in filteredCustomAnchors"
                    :key="anchor.id_doc"
                    class="ma-2"
                    outlined
                    color="primary"
                    style="cursor: pointer; user-select: none; padding-right: 8px;">
                  <span
                    @click="copyAnchorToClipboard(formatAnchor(anchor.anchorName))"
                    style="margin-right: 8px;">
                    {{ formatAnchor(anchor.anchorName) }}
                  </span>
                    <v-divider vertical style="height: 100%" />
                    <v-icon
                        v-if="!loadingAnchors[anchor.id_doc]"
                        small
                        color="#FF7F50"
                        @click.stop="deleteAnchor(anchor.id_doc)"
                        style="cursor: pointer; padding: 5px">
                      mdi-delete
                    </v-icon>
                    <v-icon
                        v-else
                        small
                        color="#FF7F50"
                        class="mdi-spin"
                        style="cursor: pointer; padding: 5px">
                      mdi-loading
                    </v-icon>
                  </v-chip>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  id="file-upload"
                  label="Upload do Template"
                  v-model="templateContractFile"
                  accept=".docx"
                  outlined
                  :rules="ruleRequired"
                  prepend-icon=""
                  prepend-inner-icon="mdi-upload"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import ContractsScript from './ContractsScript';

export default ContractsScript;
</script>

<style scoped>
</style>